// extracted by mini-css-extract-plugin
var _1 = "Extra-moduledivider__zSiJF";
var _2 = "Extra-moduleextra__soS_k";
export { _1 as "divider", _2 as "extra" }
